import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-one',
  templateUrl: './service-one.component.html',
  styleUrls: ['./service-one.component.css']
})
export class ServiceOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
